// Build-internals gate (ADR-0031): true for Operator and Admin, who see extraction status and coverage, quality flags, confidence, provenance, run ids and job internals; readers see grid-code content and results only.
import type { Role } from "@/api/__generated__";
import { canAccess } from "@/app/nav";
import { useRoles } from "@/app/session";

export function canSeeInternalDetails(roles: readonly Role[]): boolean {
  return canAccess(roles, "O");
}

export function useInternalDetails(): boolean {
  return canSeeInternalDetails(useRoles());
}
